import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppConfig } from './app-config';
import { BaseService } from './base/base.service';
import { ListResponse, ObjectResponse } from './../interfaces';
import { Country } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CountriesService extends BaseService<Country> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public show(countryId: number): Observable<ObjectResponse<Country>> {
    return this.http.get<ObjectResponse<Country>>(`${this.getResourceUrl()}${countryId}`);
  }

  // TODO: override, remove when all responses changed
  public list(queryString?: string): Observable<ListResponse<Country>> {
    const apiUrl = this.applyQueryString(queryString);

    return this.http.get<ListResponse<Country>>(apiUrl);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}countries/`;
  }

}
